/** Event emitted when TORT receives a final backend/gateway-unavailable
 * response (HTTP 500/502/503/504). */
export const TORT_TEMPORARILY_UNAVAILABLE_EVENT =
  'tort-temporarily-unavailable'

export type TortTemporarilyUnavailableDetail = { status?: number }

/**
 * Notifies the application shell that TORT is temporarily unavailable.
 * @param status - The triggering response's HTTP status, when known — lets
 * the shell show a status-specific message (e.g. 504 gets the "email
 * NAT-TORT@kp.org" copy) instead of the generic outage message.
 */
export const notifyTortTemporarilyUnavailable = (status?: number): void => {
  globalThis.dispatchEvent(
    new CustomEvent<TortTemporarilyUnavailableDetail>(
      TORT_TEMPORARILY_UNAVAILABLE_EVENT,
      { detail: { status } }
    )
  )
}